"use client";

import { useState } from "react";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";

export default function CustomAccordion({
  items = [],
  textColor = "#B3594D",
  borderColor = "rgba(179,89,77,0.5)",
  iconSrc = "/Icons/RedBottomSide.svg",
  iconSize = 30,
  questionTextClass = "",
  answerTextClass = "",
  iconAlt = "arrow icon",
  contentWidth = "w-[65%]"
}) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      {items.map((item, index) => {
        const isOpen = openIndex === index;

        return (
          <div key={index} className={`border-t-2 py-4`} style={{ borderColor: borderColor }}>
            {/* Accordion Header */}
            <div
              className={`flex justify-between items-center cursor-pointer ${questionTextClass}`}
              style={{ color: textColor }}
              onClick={() => toggle(index)}
            >
              <span className="w-[87%]"> {item.question} </span>
              <motion.div
                animate={{ rotate: isOpen ? 180 : 0 }}
                transition={{ duration: 0.3 }}
                className="w-6 h-6 lg:w-[2.18vw] lg:h-[2.18vw] flex-shrink-0"
              >
                <Image
                  src={iconSrc}
                  width={iconSize}
                  height={iconSize}
                  alt={iconAlt}
                  className={`transition-transform duration-300 w-6 h-6 lg:w-[2.18vw] lg:h-[2.18vw]`}
                />
              </motion.div>
            </div>

            {/* Accordion Content */}
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className={`overflow-hidden mt-2 pr-2 ${answerTextClass}`}
                  style={{ color: textColor }}
                >
                  <div className={contentWidth}>{item.answer}</div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
